module.exports = __webpack_public_path__ + "static/img/12.0e0efb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/sp/12.png
// module id = bXC4
// module chunks = 0